import { createApiClient } from "./apiClient";

export class CompanyService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/company");
  }

  async getCompany() {
    const res = await this.apiClient.get();
    return { name: res?.name, shouldOnboard: res?.should_onboard ?? false };
  }

  async getPasswordRules() {
    return this.apiClient.get("password-rules");
  }

  async getTheme() {
    return this.apiClient.get("theme");
  }

  async setTheme(name) {
    return this.apiClient.patch("theme", { name });
  }

  async getSettings() {
    const res = await this.apiClient.get("settings");
    return { autoLogoutAfter: res?.auto_logout_after };
  }

  async setSettings(settings) {
    return this.apiClient.post("settings", settings);
  }
}
